import axios from 'axios'
// create an axios instance 创建axios实例
const service = axios.create({
  timeout: 5000, // request timeout
  withCredentials: true
})

// request interceptor 请求拦截
service.interceptors.request.use(config => {
  // Do something before request is sent
  // const KeyAip = 'eyJhbGciOiJIUzI1NiIsInR5cCI6IkpXVCJ9.eyJ0eXBlIjoiQVBQIiwidGltZXN0YW1wIjoxNTQ3NzA3MjIwNDI0LCJwaG9uZSI6IjEzOTgzMDkxMjc1IiwidXNlcklkIjoiMjc3MjkyY2QtOWM1YS00OTE1LWE4ZGQtNTAyNzhiMjBiMzUxIiwiaGVhZGltZ1VybCI6Imh0dHBzOi8vY2VzaGkubW90b3Jqb3VybmV5LmNuLzE1MzI0ODYzMjQ2NzQuanBnIiwibmlja25hbWUiOiLlkInku5YiLCJ1c2VybmFtZSI6IjEzOTgzMDkxMjc1IiwiaWF0IjoxNTQ3NzA3MjIwLCJleHAiOjE1NTAyOTkyMjB9.wypfavYX7-f103KKp6eYDXnCLJ47JcxKBADQaMloesE'
  config.headers['Content-Type'] = 'application/json;charset=UTF-8'
  return config
}, error => {
  // Do something with request error
  console.log(error) // for debug
  Promise.reject(error)
})

// respone interceptor 响应拦截
service.interceptors.response.use(
  response => {
    return response
  }, error => {
    console.log('err' + error)// for debug
    return Promise.reject(error)
  })

export default service
